  <div class="player-main-wrapper" [ngClass]="{'audio-record': !publicId}">
  <div class="audio-list-wrapper">
    @for (blobUrl of blobUrls; track $index; let i = $index) {
    <div class="Layout">
      <div class="list-wrapper">
      <svg
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="none"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        style="-webkit-print-color-adjust: exact; flex-shrink: 0;"
        id="screenshot-34614192-5454-8094-8003-c77b7f5b51c3"
        version="1.1"
        viewBox="3854.602 119.286 26 26"
        height="22"
        class="list-wrapper-svg"
      >
        <g
          id="shape-34614192-5454-8094-8003-c77b7f5b51c3"
          style="fill: #000000"
          width="26"
          height="26"
          rx="0"
          ry="0"
        >
          <g id="shape-34614192-5454-8094-8003-c77b7f5b82bd">
            <g class="fills" id="fills-34614192-5454-8094-8003-c77b7f5b82bd">
              <path
                rx="0"
                ry="0"
                style="fill: #24b89b; fill-opacity: 1"
                d="M3873.415,121.317C3872.962,121.415,3872.645,121.824,3872.665,122.286L3872.665,141.286C3872.604,141.658,3872.768,142.030,3873.083,142.236C3873.399,142.441,3873.806,142.441,3874.121,142.236C3874.436,142.030,3874.601,141.658,3874.540,141.286L3874.540,122.286C3874.546,122.016,3874.437,121.756,3874.240,121.571C3874.043,121.386,3873.777,121.294,3873.415,121.317ZC3873.477,121.316,3873.446,121.316,3873.415,121.317ZM3861.415,122.317C3860.962,122.415,3860.645,122.824,3860.665,123.286L3860.665,140.286C3860.604,140.658,3860.768,141.030,3861.083,141.236C3861.399,141.441,3861.806,141.441,3862.121,141.236C3862.436,141.030,3862.601,140.658,3862.540,140.286L3862.540,123.286C3862.546,123.016,3862.437,122.756,3862.240,122.571C3862.043,122.386,3861.777,122.294,3861.415,122.317ZC3861.477,122.316,3861.446,122.316,3861.415,122.317ZM3870.415,125.317C3869.962,125.415,3869.645,125.824,3869.665,126.286L3869.665,137.286C3869.603,137.658,3869.766,138.032,3870.082,138.238C3870.398,138.445,3870.806,138.445,3871.121,138.238C3871.437,138.032,3871.601,137.658,3871.539,137.286L3871.539,126.286C3871.545,126.017,3871.436,125.757,3871.240,125.572C3871.043,125.387,3870.778,125.295,3870.415,125.317ZC3870.477,125.316,3870.445,125.316,3870.415,125.317ZZM3858.415,126.317C3857.962,126.415,3857.645,126.824,3857.665,127.286L3857.665,136.286C3857.603,136.658,3857.766,137.032,3858.082,137.238C3858.398,137.445,3858.806,137.445,3859.121,137.238C3859.437,137.032,3859.601,136.658,3859.539,136.286L3859.539,127.286C3859.545,127.017,3859.436,126.757,3859.240,126.572C3859.043,126.387,3858.778,126.295,3858.415,126.317ZC3858.477,126.316,3858.445,126.316,3858.415,126.317ZZM3864.415,127.317C3863.962,127.415,3863.645,127.824,3863.665,128.286L3863.665,135.286C3863.603,135.658,3863.766,136.032,3864.082,136.238C3864.398,136.445,3864.806,136.445,3865.121,136.238C3865.437,136.032,3865.601,135.658,3865.539,135.286L3865.539,128.286C3865.545,128.017,3865.436,127.757,3865.240,127.572C3865.043,127.387,3864.778,127.295,3864.415,127.317ZC3864.477,127.316,3864.445,127.316,3864.415,127.317ZZM3876.415,127.317C3875.962,127.415,3875.645,127.824,3875.665,128.286L3875.665,135.286C3875.604,135.658,3875.768,136.030,3876.083,136.236C3876.399,136.441,3876.806,136.441,3877.121,136.236C3877.436,136.030,3877.601,135.658,3877.540,135.286L3877.540,128.286C3877.546,128.016,3877.437,127.756,3877.240,127.571C3877.043,127.386,3876.777,127.294,3876.415,127.317ZC3876.477,127.316,3876.446,127.316,3876.415,127.317ZM3855.415,129.317C3854.962,129.415,3854.645,129.824,3854.665,130.286L3854.665,133.286C3854.604,133.658,3854.768,134.030,3855.083,134.236C3855.399,134.441,3855.806,134.441,3856.121,134.236C3856.436,134.030,3856.601,133.658,3856.540,133.286L3856.540,130.286C3856.546,130.016,3856.437,129.756,3856.240,129.571C3856.043,129.386,3855.777,129.294,3855.415,129.317ZC3855.476,129.316,3855.445,129.316,3855.415,129.317ZZM3867.415,129.317C3866.962,129.415,3866.645,129.824,3866.665,130.286L3866.665,133.286C3866.603,133.658,3866.766,134.032,3867.082,134.238C3867.398,134.445,3867.806,134.445,3868.121,134.238C3868.437,134.032,3868.601,133.658,3868.539,133.286L3868.539,130.286C3868.545,130.017,3868.436,129.757,3868.240,129.572C3868.043,129.387,3867.778,129.295,3867.415,129.317ZC3867.477,129.316,3867.445,129.316,3867.415,129.317ZZM3879.415,129.317C3878.962,129.415,3878.645,129.824,3878.665,130.286L3878.665,133.286C3878.604,133.658,3878.768,134.030,3879.083,134.236C3879.399,134.441,3879.806,134.441,3880.121,134.236C3880.436,134.030,3880.601,133.658,3880.540,133.286L3880.540,130.286C3880.546,130.016,3880.437,129.756,3880.240,129.571C3880.043,129.386,3879.777,129.294,3879.415,129.317ZC3879.477,129.316,3879.446,129.316,3879.415,129.317Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
      <!-- <span class="font-14px ms-2">Audio{{ i + 1 }}.mp3</span> -->
      <span class="font-14px ms-2">{{blobUrl?.filename}}</span>
      </div>
      <div class="d-flex justify-content-end align-items-center gap-4 gap-lg-2">
        <div id="play-button-{{ i }}" (click)="toggleAudio(i)" style="cursor: pointer; display: flex; align-items: center; justify-content: center;" [ngClass]="{ 'disabled': isRecording }">
          @if(!audioPlaying[i]) {
          <ng-container>
            <i class="fa-solid fa-circle-play btn-play"></i>
          </ng-container>
          } @else {
          <ng-container>
            <i class="fa-solid fa-circle-stop btn-play"></i>
          </ng-container>
          }
        </div>
        <!-- deleteAudio(i) -->
        <div class="" (click)="showDeleteConfirmation(i,'audio')" style="cursor: pointer;" [ngClass]="{ 'disabled': isRecording }" *ngIf="isDeleteActive">
          <i class="fa-solid fa-trash btn-play btn-video-delete"></i>
        </div>

        <ng-container *ngIf="!publicId && currentRole == 'Admin'">
          <div (click)="acceptAudio(i)" class="d-flex">
            <span class="status" *ngIf="blobUrl.status !== 'accepted'  ">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="#666666"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"></path></svg>
            </span>
            <span class="status-checked flex-shrink-0" *ngIf="blobUrl.status === 'accepted'">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path></svg>
            </span>
          </div>
          <div (click)="rejectAudio(i)" class="d-flex">
           <span class="status" *ngIf="blobUrl.status !== 'rejected'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="#666666"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path></svg>
           </span>
           <span class="status-rejected" *ngIf="blobUrl.status === 'rejected'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"></path></svg>
           </span>
          </div>
        </ng-container>

      </div>
    </div>
    <audio id="audioTag-{{ i }}"  ><source [src]="mediaVoiceFiles[i]" type="audio/webm" /></audio>
    }
  </div>

  <div class="video-list-wrapper">
    @for (videoFile of agent.videoFiles; track videoFile.id; let i = $index) {
    <div class="Layout">
      <div class="list-wrapper">
        <i class="fa-solid fa-film" style="font-size: 20px;"></i>
        <!-- <span class="font-14px ms-2 video-list-name">Video{{ i + 1 }}.mp4</span> -->
        <span class="font-14px ms-2 video-list-name">{{videoFile.filename}}</span>
      </div>
      <div class="d-flex justify-content-end align-items-center gap-4 gap-lg-2">
        <div id="play-button-{{ i }}" (click)="playVideo(videoFile)" style="display: flex; align-items: center; justify-content: center;" [ngClass]="{ 'disabled': isRecording }">
          @if(!videoPlaying[i]) {
          <ng-container>
            <i class="fa-solid fa-circle-play btn-video-play" style="cursor: pointer;"></i>
          </ng-container>
          } @else {
          <ng-container>
            <i class="fa-solid fa-circle-stop btn-play"></i>
          </ng-container>
          }
        </div>
        <!-- deleteVideo(i) -->
        <div class="" (click)="showDeleteConfirmation(i,'video')" style="cursor: pointer;" [ngClass]="{ 'disabled': isRecording }" *ngIf="isDeleteActive">
          <i class="fa-solid fa-trash btn-video-delete"></i>
        </div>

        <ng-container *ngIf="!publicId && currentRole == 'Admin'">
          <div (click)="acceptVideo(videoFile)" class="d-flex">
            <span class="status" *ngIf="videoFile.status !== 'accepted'">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="#666666"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11.0026 16L6.75999 11.7574L8.17421 10.3431L11.0026 13.1716L16.6595 7.51472L18.0737 8.92893L11.0026 16Z"></path></svg>
            </span>
            <span class="status-checked flex-shrink-0" *ngIf="videoFile.status === 'accepted'">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path></svg>
            </span>
          </div>
          <div (click)="rejectVideo(videoFile)" class="d-flex">
           <span class="status" *ngIf="videoFile.status !== 'rejected'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="#666666"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path></svg>
           </span>
           <span class="status-rejected" *ngIf="videoFile.status === 'rejected'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="flex-shrink-0" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"></path></svg>
           </span>
          </div>
        </ng-container>

      </div>
    </div>
    }
  </div>

  <div style="display: flex; flex-direction: column; gap: 8px;">
    <button mat-stroked-button (click)="sendVoiceFileRequest()" [disabled]="agent.status !== 'WaitingForAgent'" *ngIf="!isPublic && currentRole === 'Admin'">
      WhatsApp freischalten / Voicefile anfordern
    </button>
  
    <button mat-stroked-button (click)="copyLinkToClipboard(agent)" *ngIf="!isPublic && currentRole === 'Admin'">
      Link zur Agentenansicht kopieren
    </button>
  </div>

  @if (currentVideoBlobUrl != '') {
    <div class="backdrop" id="backdrop"></div>
    <div class="video-modal">
      <button class="cancel-button" (click)="currentVideoBlobUrl = ''"><i class="fa-solid fa-xmark"></i></button>
      <video id="videoTag" controls autoplay>
        <source [src]="currentVideoBlobUrl" type="video/webm">
      </video>
    </div>
  }
</div>


<div *ngIf="showDeleteConfirmationDialog" class="backdrop"></div>
<div *ngIf="showDeleteConfirmationDialog" class="cust-delete-dialog">
  <div class="delete-dialog-text">
    Sind Sie sicher, dass Sie dieses {{deletionType=='video'?'VideoFile':'AudioFile' }} löschen möchten?
  </div>
  <div class="bottomRow">
    <button #thisbutton_cssbutton type="button" class="cssButton"
      (click)="showDeleteConfirmationDialog = false;deletionType='';deleteIndex=-1">
      <div class="focus:outline-0 bg-transparent">
        <span> Abbrechen </span>
      </div>
    </button>
    <button #thisbutton_cssbutton2 type="button" class="cssButton" (click)="deleteFile()">
      <div class="focus:outline-0 bg-transparent">
        <span> Bestätigen </span>
      </div>
    </button>
  </div>
</div>
@if(isSpinnerActive) {
  <app-spinner></app-spinner>
}
